/**
 * A/B Test — Bundle pack messaging
 * Toggle: body[data-bundle-messaging-ab="true|false"]
 *   - false: hide 6 Pack; show default 1 / 2 / 4
 *   - true:  hide 1 Pack; show 2 / 4 / 6 with BOGO labels
 *            6 Pack gifts → Free Shipping + Free Luggage Tag + Free Air Pump
 */
(function () {
  'use strict';

  if (window.__bundleMessagingAbTestInit) return;
  window.__bundleMessagingAbTestInit = true;

  var ATTR = 'data-bundle-messaging-ab';
  var PACK_ATTR = 'data-pack-type';
  var ORIGINAL_ATTR = 'data-bundle-messaging-ab-original';
  var BADGE_ORIGINAL_ATTR = 'data-bundle-messaging-ab-badge-original';
  var GIFTS_ATTR = 'data-bundle-messaging-ab-gifts';
  var VARIANT_B_BADGE = '50% OFF';
  var LABELS = { '2': 'Buy 1 Get 1 FREE', '4': 'Buy 2 Get 2 FREE', '6': 'Buy 3 Get 3 FREE' };
  var PUMP_ICON_URL = 'https://cdn.shopify.com/s/files/1/0924/3502/2169/files/Frame65.png?v=1741943675';
  var SHIPPING_ICON_URL = 'https://cdn.shopify.com/s/files/1/0924/3502/2169/files/Frame_2.png?v=1780054692';
  var LUGGAGE_ICON_URL = 'https://cdn.shopify.com/s/files/1/0924/3502/2169/files/image_363.png?v=1779712168';
  var DEFAULT_PACK = '2';
  var timer = null;
  var applying = false;
  var selecting = false;
  var mutating = false;
  var userPickedPack = false;
  var defaultApplied = false;
  var lastEnabled = null;
  var lastKachingInteraction = 0;
  var giftRetryTimer = null;

  function isAbEnabled() {
    if (!document.body) return false;
    var bodyVal = document.body.getAttribute(ATTR);
    if (bodyVal === 'true') return true;
    if (bodyVal === 'false') return false;
    return document.body.getAttribute('data-bundle-messaging-ab-setting') === 'true';
  }

  function isBundleSelectorAb() {
    return document.body && document.body.getAttribute('data-bundle-selector-ab') === 'true';
  }

  function isAirpumpAbActive() {
    if (!document.body) return false;
    return document.body.getAttribute('data-bundle-messaging-airpump-ab') === 'true' ||
      document.body.classList.contains('bundle-messaging-airpump-ab--active');
  }

  function hasKachingBundles() {
    return document.querySelectorAll('.kaching-bundles__bar').length > 0;
  }

  function normalize(text) {
    return String(text || '').replace(/\s+/g, ' ').trim();
  }

  function detectPackType(text) {
    var n = normalize(text).toLowerCase();
    if (n.indexOf('buy 3 get 3') > -1) return '6';
    if (n.indexOf('buy 2 get 2') > -1) return '4';
    if (n.indexOf('buy 1 get 1') > -1) return '2';
    if (/\b6\s*pack\b/.test(n)) return '6';
    if (/\b4\s*pack\b/.test(n)) return '4';
    if (/\b2\s*pack\b/.test(n)) return '2';
    if (/\b1\s*pack\b/.test(n)) return '1';
    return null;
  }

  function getKachingTitleEl(bar) {
    return bar.querySelector('.kaching-bundles__bar-title') ||
      bar.querySelector('[class*="bar-title"]:not([class*="bar-label"])');
  }

  function getSwatchTitleEl(swatch) {
    return swatch.querySelector('.bundletitle');
  }

  function getDiscountBadge(node) {
    if (!node) return null;

    var badges = node.querySelectorAll(
      '.discount-percentage, .igSavingsPercentage, .main-wrap-label, .green-badge, [class*="bar-badge"], [class*="bar-saving"]'
    );
    var i;
    var badge;

    for (i = 0; i < badges.length; i++) {
      badge = badges[i];
      if (badge.classList.contains('most-popular')) continue;
      if (/\d+%\s*OFF/i.test(normalize(badge.textContent))) return badge;
    }

    return null;
  }

  function applyDiscountBadges() {
    var nodes = [];

    document.querySelectorAll('.variant-picker__option .block-swatch[data-pack-type]').forEach(function (node) {
      nodes.push(node);
    });

    if (hasKachingBundles()) {
      document.querySelectorAll('.kaching-bundles__bar[data-pack-type]').forEach(function (node) {
        nodes.push(node);
      });
    }

    nodes.forEach(function (node) {
      var packType = node.getAttribute(PACK_ATTR);
      if (!packType || packType === '1') return;

      var badge = getDiscountBadge(node);
      if (!badge) return;

      if (!badge.getAttribute(BADGE_ORIGINAL_ATTR)) {
        badge.setAttribute(BADGE_ORIGINAL_ATTR, normalize(badge.textContent));
      }
      if (normalize(badge.textContent) !== VARIANT_B_BADGE) {
        badge.textContent = VARIANT_B_BADGE;
      }
    });
  }

  function restoreDiscountBadges() {
    document.querySelectorAll('[' + BADGE_ORIGINAL_ATTR + ']').forEach(function (badge) {
      var original = badge.getAttribute(BADGE_ORIGINAL_ATTR);
      if (original) badge.textContent = original;
      badge.removeAttribute(BADGE_ORIGINAL_ATTR);
    });
  }

  function getBarPackType(bar, index) {
    var stored = bar.getAttribute(PACK_ATTR);
    if (stored) return stored;

    var titleEl = getKachingTitleEl(bar);
    var fromText = titleEl ? detectPackType(titleEl.textContent) : null;
    if (fromText) return fromText;

    var bars = document.querySelectorAll('.kaching-bundles__bar');
    if (bars.length === 2) {
      return index === 0 ? '2' : '4';
    }
    if (bars.length === 4) {
      return index === 0 ? '1' : index === 1 ? '2' : index === 2 ? '4' : '6';
    }

    return index === 0 ? '1' : index === 1 ? '2' : index === 2 ? '4' : index === 3 ? '6' : null;
  }

  function tagPackNodes() {
    var bars = document.querySelectorAll('.kaching-bundles__bar');
    var i;
    var packType;

    for (i = 0; i < bars.length; i++) {
      packType = getBarPackType(bars[i], i);
      if (packType) bars[i].setAttribute(PACK_ATTR, packType);
    }

    document.querySelectorAll('.variant-picker__option').forEach(function (fieldset) {
      if (!fieldset.querySelector('.bundletitle')) return;
      fieldset.querySelectorAll('.block-swatch').forEach(function (swatch, index) {
        var titleEl = getSwatchTitleEl(swatch);
        var type = titleEl ? detectPackType(titleEl.textContent) : null;
        if (!type) {
          var count = fieldset.querySelectorAll('.block-swatch').length;
          if (count === 2) type = index === 0 ? '2' : '4';
          else if (count === 4) type = index === 0 ? '1' : index === 1 ? '2' : index === 2 ? '4' : '6';
          else type = index === 0 ? '1' : index === 1 ? '2' : index === 2 ? '4' : index === 3 ? '6' : null;
        }
        if (type) swatch.setAttribute(PACK_ATTR, type);
      });
    });
  }

  function applyLabels() {
    if (hasKachingBundles()) {
      document.querySelectorAll('.kaching-bundles__bar[data-pack-type]').forEach(function (bar) {
        var packType = bar.getAttribute(PACK_ATTR);
        var label = LABELS[packType];
        var titleEl = getKachingTitleEl(bar);
        if (!label || !titleEl) return;

        if (!titleEl.getAttribute(ORIGINAL_ATTR)) {
          titleEl.setAttribute(ORIGINAL_ATTR, normalize(titleEl.textContent));
        }
        if (normalize(titleEl.textContent) !== label) {
          titleEl.textContent = label;
        }
      });
      return;
    }

    document.querySelectorAll('.variant-picker__option .block-swatch[data-pack-type]').forEach(function (swatch) {
      var packType = swatch.getAttribute(PACK_ATTR);
      var label = LABELS[packType];
      var titleEl = getSwatchTitleEl(swatch);
      if (!label || !titleEl) return;

      if (!titleEl.getAttribute(ORIGINAL_ATTR)) {
        titleEl.setAttribute(ORIGINAL_ATTR, normalize(titleEl.textContent));
      }
      if (normalize(titleEl.textContent) !== label) {
        titleEl.textContent = label;
      }
    });
  }

  function restoreLabels() {
    document.querySelectorAll('[' + ORIGINAL_ATTR + ']').forEach(function (el) {
      var original = el.getAttribute(ORIGINAL_ATTR);
      if (original) el.textContent = original;
      el.removeAttribute(ORIGINAL_ATTR);
    });
  }

  function hideFirstPackNodes(enabled) {
    document.querySelectorAll(
      '.kaching-bundles__bar[data-pack-type="1"], .variant-picker__option .block-swatch[data-pack-type="1"]'
    ).forEach(function (node) {
      if (!enabled) {
        node.removeAttribute('aria-hidden');
        node.classList.remove('bundle-messaging-ab__hidden');
        return;
      }
      node.setAttribute('aria-hidden', 'true');
      node.classList.add('bundle-messaging-ab__hidden');
    });
  }

  function setSixPackVisibility(show) {
    document.querySelectorAll(
      '.kaching-bundles__bar[data-pack-type="6"], ' +
      '.variant-picker__option .block-swatch[data-pack-type="6"], ' +
      '.variant-picker__option .block-swatch--pack-6'
    ).forEach(function (node) {
      if (show) {
        node.removeAttribute('aria-hidden');
        node.classList.remove('bundle-messaging-ab__six-hidden');
        return;
      }
      node.setAttribute('aria-hidden', 'true');
      node.classList.add('bundle-messaging-ab__six-hidden');
    });
  }

  function getPackSixHosts() {
    return document.querySelectorAll(
      '.kaching-bundles__bar[data-pack-type="6"], ' +
      '.variant-picker__option .block-swatch[data-pack-type="6"], ' +
      '.variant-picker__option .block-swatch--pack-6'
    );
  }

  function getSourceGiftList() {
    var selectors = [
      '.kaching-bundles__bar[data-pack-type="4"] .bundle-perks',
      '.kaching-bundles__bar[data-pack-type="4"] .kaching-bundles__bar-subtitles',
      '.kaching-bundles__bar[data-pack-type="4"] .kaching-bundles__bar-subtitle-list',
      '.block-swatch[data-pack-type="4"] .bundle-perks',
      '.block-swatch--pack-4 .bundle-perks'
    ];
    var i;
    var list;
    for (i = 0; i < selectors.length; i++) {
      list = document.querySelector(selectors[i]);
      if (list) return list;
    }

    // Fallback: find Free Shipping / Luggage Tag nodes under pack 4 and use their parent
    var pack4 = document.querySelector(
      '.kaching-bundles__bar[data-pack-type="4"], .block-swatch[data-pack-type="4"], .block-swatch--pack-4'
    );
    if (!pack4) return null;

    var nodes = pack4.querySelectorAll('div, span, p, li');
    var giftParent = null;
    for (i = 0; i < nodes.length; i++) {
      var text = normalize(nodes[i].textContent).toLowerCase();
      if (text.indexOf('free shipping') > -1 && text.indexOf('luggage') > -1) {
        giftParent = nodes[i];
        break;
      }
      if (text.indexOf('free shipping') > -1 || text.indexOf('luggage tag') > -1) {
        var parent = nodes[i].parentElement;
        if (parent && parent !== pack4) giftParent = parent;
      }
    }
    return giftParent;
  }

  function buildFallbackGiftList() {
    var list = document.createElement('div');
    list.className = 'bundle-perks bundle-perks--banner bundle-messaging-ab__pack6-gifts';
    list.setAttribute(GIFTS_ATTR, 'true');
    list.innerHTML =
      '<div class="bundle-perk bundle-perk--shipping">' +
      '<span class="bundle-perk__row" data-bundle-perk-row="true">' +
      '<span class="bundle-perk__icon bundle-perk__icon--shipping" aria-hidden="true">' +
      '<img src="' + SHIPPING_ICON_URL + '" alt="" width="20" height="20" loading="lazy" decoding="async">' +
      '</span>' +
      '<span class="bundle-perk__text">+ Free Shipping</span>' +
      '</span></div>' +
      '<div class="bundle-perk bundle-perk--luggage">' +
      '<span class="bundle-perk__row" data-bundle-perk-row="true">' +
      '<span class="bundle-perk__icon bundle-perk__icon--luggage" aria-hidden="true">' +
      '<img src="' + LUGGAGE_ICON_URL + '" alt="" width="20" height="20" loading="lazy" decoding="async">' +
      '</span>' +
      '<span class="bundle-perk__text">+ Free Luggage Tag ($97 Value)</span>' +
      '</span></div>' +
      '<div class="bundle-perk bundle-perk--airpump" data-bundle-messaging-ab-airpump="true">' +
      '<span class="bundle-perk__row" data-bundle-perk-row="true">' +
      '<span class="bundle-perk__icon bundle-perk__icon--airpump">' +
      '<img src="' + PUMP_ICON_URL + '" alt="" width="20" height="20" loading="lazy" decoding="async">' +
      '</span>' +
      '<span class="bundle-perk__text">+ Free Air Pump</span>' +
      '</span></div>';
    return list;
  }

  function buildAirPumpPerk(list) {
    var template = list.querySelector('.bundle-perk--luggage') ||
      list.querySelector('.bundle-perk--shipping') ||
      list.querySelector('.bundle-perk') ||
      list.querySelector('.kaching-bundles__bar-subtitle');
    var perk;

    if (template && template.classList.contains('kaching-bundles__bar-subtitle')) {
      perk = template.cloneNode(true);
      perk.setAttribute('data-bundle-messaging-ab-airpump', 'true');
      perk.innerHTML =
        '<span class="bundle-perk__icon bundle-perk__icon--airpump">' +
        '<img src="' + PUMP_ICON_URL + '" alt="" width="20" height="20" loading="lazy" decoding="async">' +
        '</span>' +
        '<span>+ Free Air Pump</span>';
      return perk;
    }

    if (template) {
      perk = template.cloneNode(true);
      perk.className = 'bundle-perk bundle-perk--airpump';
      perk.setAttribute('data-bundle-messaging-ab-airpump', 'true');

      var icon = perk.querySelector('.bundle-perk__icon');
      if (icon) {
        icon.className = 'bundle-perk__icon bundle-perk__icon--airpump';
        icon.innerHTML =
          '<img src="' + PUMP_ICON_URL + '" alt="" width="20" height="20" loading="lazy" decoding="async">';
      }

      var text = perk.querySelector('.bundle-perk__text');
      if (text) text.textContent = '+ Free Air Pump';
      else {
        var span = document.createElement('span');
        span.className = 'bundle-perk__text';
        span.textContent = '+ Free Air Pump';
        perk.appendChild(span);
      }
      return perk;
    }

    perk = document.createElement('div');
    perk.className = 'bundle-perk bundle-perk--airpump';
    perk.setAttribute('data-bundle-messaging-ab-airpump', 'true');
    perk.innerHTML =
      '<span class="bundle-perk__row" data-bundle-perk-row="true">' +
      '<span class="bundle-perk__icon bundle-perk__icon--airpump">' +
      '<img src="' + PUMP_ICON_URL + '" alt="" width="20" height="20" loading="lazy" decoding="async">' +
      '</span>' +
      '<span class="bundle-perk__text">+ Free Air Pump</span>' +
      '</span>';
    return perk;
  }

  function getPackSixGiftMount(host) {
    // Place gifts BELOW .swatch-wrap (not inside — row flex breaks the header)
    var swatchWrap = host.querySelector(':scope > .swatch-wrap') || host.querySelector('.swatch-wrap');
    if (swatchWrap) {
      return { parent: swatchWrap.parentNode || host, after: swatchWrap };
    }
    var mainWrap = host.querySelector('.main-wrap');
    if (mainWrap && mainWrap.parentNode) {
      return { parent: mainWrap.parentNode, after: mainWrap };
    }
    var barContent = host.querySelector('.kaching-bundles__bar-container, .kaching-bundles__bar-content');
    if (barContent) {
      return { parent: barContent.parentNode || host, after: barContent };
    }
    return { parent: host, after: null };
  }

  function placePackSixGifts(host, gifts) {
    var mount = getPackSixGiftMount(host);
    host.classList.add('bundle-messaging-ab__pack6-card');

    if (gifts.parentNode) gifts.parentNode.removeChild(gifts);

    if (mount.after && mount.after.parentNode === mount.parent) {
      if (mount.after.nextSibling) {
        mount.parent.insertBefore(gifts, mount.after.nextSibling);
      } else {
        mount.parent.appendChild(gifts);
      }
    } else {
      mount.parent.appendChild(gifts);
    }
  }

  function ensurePackSixGifts() {
    if (mutating) return;
    mutating = true;

    try {
      getPackSixHosts().forEach(function (host) {
        var existing = host.querySelector('[' + GIFTS_ATTR + ']');
        if (existing) {
          if (!existing.querySelector('[data-bundle-messaging-ab-airpump]')) {
            existing.appendChild(buildAirPumpPerk(existing));
          }
          placePackSixGifts(host, existing);
          return;
        }

        var source = getSourceGiftList();
        var gifts;

        if (source) {
          gifts = source.cloneNode(true);
          gifts.setAttribute(GIFTS_ATTR, 'true');
          gifts.classList.add('bundle-messaging-ab__pack6-gifts');
          gifts.querySelectorAll('[data-bundle-airpump-gift], .bundle-perk--airpump, [data-bundle-messaging-ab-airpump]').forEach(function (el) {
            if (el.parentNode) el.parentNode.removeChild(el);
          });
          if (!gifts.querySelector('[data-bundle-messaging-ab-airpump], .bundle-perk--airpump')) {
            gifts.appendChild(buildAirPumpPerk(gifts));
          }
        } else {
          gifts = buildFallbackGiftList();
        }

        placePackSixGifts(host, gifts);
      });
    } finally {
      mutating = false;
    }
  }

  function restorePackSixGifts() {
    document.querySelectorAll('[' + GIFTS_ATTR + ']').forEach(function (el) {
      if (el.parentNode) el.parentNode.removeChild(el);
    });
    document.querySelectorAll('.bundle-messaging-ab__pack6-card').forEach(function (el) {
      el.classList.remove('bundle-messaging-ab__pack6-card');
    });
  }

  function retryPackSixGifts() {
    if (!isAbEnabled() || isBundleSelectorAb()) {
      restorePackSixGifts();
      return;
    }
    if (giftRetryTimer) clearTimeout(giftRetryTimer);
    giftRetryTimer = setTimeout(function () {
      if (applying || mutating) return;
      if (!isAbEnabled() || isBundleSelectorAb()) {
        restorePackSixGifts();
        return;
      }
      tagPackNodes();
      setSixPackVisibility(true);
      ensurePackSixGifts();
    }, 80);
  }

  function isBarSelected(bar) {
    if (!bar) return false;
    if (bar.classList.contains('kaching-bundles__bar--selected') ||
        bar.getAttribute('aria-checked') === 'true') return true;
    var radio = bar.querySelector('input[type="radio"]');
    return !!(radio && radio.checked);
  }

  function isSwatchSelected(swatch) {
    if (!swatch) return false;
    if (swatch.classList.contains('is-selected')) return true;
    var inputId = swatch.getAttribute('for');
    var radio = swatch.querySelector('input[type="radio"]') ||
      (inputId ? document.getElementById(inputId) : null);
    return !!(radio && radio.checked);
  }

  function getPackSwatches() {
    var swatches = [];
    document.querySelectorAll('.variant-picker__option .block-swatch[data-pack-type]').forEach(function (swatch) {
      if (swatch.getAttribute(PACK_ATTR) !== '1') swatches.push(swatch);
    });
    return swatches;
  }

  function getSelectedPack(source) {
    var nodes = source === 'kaching'
      ? document.querySelectorAll('.kaching-bundles__bar')
      : getPackSwatches();
    var i;
    var node;

    for (i = 0; i < nodes.length; i++) {
      node = nodes[i];
      if (source === 'kaching' ? !isBarSelected(node) : !isSwatchSelected(node)) continue;
      return node.getAttribute(PACK_ATTR);
    }
    return null;
  }

  function selectKachingBar(bar) {
    if (!bar || bar.getAttribute('aria-hidden') === 'true') return false;
    selecting = true;
    try {
      var clickable =
        bar.querySelector('.kaching-bundles__bar-container') ||
        bar.querySelector('[role="radio"]') ||
        bar;
      if (clickable && typeof clickable.click === 'function') clickable.click();
      return isBarSelected(bar);
    } finally {
      selecting = false;
    }
  }

  function selectSwatch(swatch) {
    if (!swatch || swatch.getAttribute('aria-hidden') === 'true') return false;
    selecting = true;
    try {
      if (typeof swatch.click === 'function') swatch.click();
      return isSwatchSelected(swatch);
    } finally {
      selecting = false;
    }
  }

  function findPackNode(packType, source) {
    var selector = source === 'kaching'
      ? '.kaching-bundles__bar[data-pack-type="' + packType + '"]'
      : '.variant-picker__option .block-swatch[data-pack-type="' + packType + '"]';
    return document.querySelector(selector);
  }

  function maybeApplyDefaultSelection() {
    if (userPickedPack || defaultApplied) return;

    var useKaching = hasKachingBundles();
    var selected = useKaching ? getSelectedPack('kaching') : getSelectedPack('swatch');

    if (selected && selected !== '1') {
      defaultApplied = true;
      return;
    }

    if (useKaching) {
      if (selectKachingBar(findPackNode(DEFAULT_PACK, 'kaching'))) defaultApplied = true;
      return;
    }

    if (getPackSwatches().length && selectSwatch(findPackNode(DEFAULT_PACK, 'swatch'))) {
      defaultApplied = true;
    }
  }

  function fixHiddenPackSelection() {
    if (userPickedPack) return;
    var useKaching = hasKachingBundles();
    var selected = useKaching ? getSelectedPack('kaching') : getSelectedPack('swatch');
    var enabled = isAbEnabled() && !isBundleSelectorAb();

    if (enabled && selected === '1') {
      if (useKaching) selectKachingBar(findPackNode(DEFAULT_PACK, 'kaching'));
      else selectSwatch(findPackNode(DEFAULT_PACK, 'swatch'));
      return;
    }

    if (!enabled && selected === '6') {
      if (useKaching) selectKachingBar(findPackNode(DEFAULT_PACK, 'kaching'));
      else selectSwatch(findPackNode(DEFAULT_PACK, 'swatch'));
    }
  }

  function applyTest() {
    if (applying) return;
    applying = true;

    try {
      var enabled = isAbEnabled() && !isBundleSelectorAb();

      if (lastEnabled !== enabled) {
        userPickedPack = false;
        defaultApplied = false;
        lastEnabled = enabled;
      }

      document.body.classList.toggle('bundle-messaging-ab--active', enabled);

      // Always tag so 6 Pack can be targeted while hidden in control
      tagPackNodes();

      if (!enabled) {
        hideFirstPackNodes(false);
        // Airpump AB owns Pack of 6 when it is on — do not hide it here
        if (!isAirpumpAbActive()) {
          setSixPackVisibility(false);
        } else {
          setSixPackVisibility(true);
        }
        restoreLabels();
        restoreDiscountBadges();
        restorePackSixGifts();
        if (!isAirpumpAbActive()) fixHiddenPackSelection();
        return;
      }

      hideFirstPackNodes(true);
      setSixPackVisibility(true);
      applyLabels();
      applyDiscountBadges();
      ensurePackSixGifts();
      fixHiddenPackSelection();
      maybeApplyDefaultSelection();
      retryPackSixGifts();
    } finally {
      applying = false;
    }
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(applyTest, 0);
  }

  function onPackPick(event) {
    if (selecting || !isAbEnabled() || isBundleSelectorAb()) return;
    if (event.target.closest('.kaching-bundles__bar')) {
      userPickedPack = true;
      lastKachingInteraction = Date.now();
      requestAnimationFrame(function () {
        applyLabels();
        applyDiscountBadges();
        ensurePackSixGifts();
      });
      return;
    }
    if (event.target.closest('.variant-picker__option-values .block-swatch[data-pack-type]')) {
      userPickedPack = true;
      requestAnimationFrame(ensurePackSixGifts);
    }
  }

  function onVariantUpdate() {
    if (!isAbEnabled() || isBundleSelectorAb()) return;
    if (Date.now() - lastKachingInteraction < 500) return;
    schedule();
  }

  function init() {
    applyTest();

    document.addEventListener('click', onPackPick, true);
    document.addEventListener('variant:change', onVariantUpdate);
    document.addEventListener('product:rerender', onVariantUpdate);

    new MutationObserver(function (mutations) {
      if (applying) return;
      var run = false;
      mutations.forEach(function (m) {
        if (
          m.attributeName === ATTR ||
          m.attributeName === 'data-bundle-selector-ab' ||
          m.attributeName === 'data-bundle-messaging-airpump-ab'
        ) {
          run = true;
        }
      });
      if (run) schedule();
    }).observe(document.body, {
      attributes: true,
      attributeFilter: [ATTR, 'data-bundle-selector-ab', 'data-bundle-messaging-airpump-ab']
    });

    new MutationObserver(function (mutations) {
      if (applying) return;
      if (Date.now() - lastKachingInteraction < 500) return;

      var run = false;
      mutations.forEach(function (m) {
        if (m.type !== 'childList' || !m.addedNodes.length) return;
        var i;
        var node;
        for (i = 0; i < m.addedNodes.length; i++) {
          node = m.addedNodes[i];
          if (node.nodeType !== 1) continue;
          if (
            (node.matches && node.matches('.kaching-bundles__bar, kaching-bundle, kaching-bundles')) ||
            (node.querySelector && node.querySelector('.kaching-bundles__bar'))
          ) {
            run = true;
            break;
          }
        }
      });
      if (run) schedule();
    }).observe(document.body, { childList: true, subtree: true });

    [100, 400, 1000, 2500].forEach(function (ms) {
      setTimeout(applyTest, ms);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('load', applyTest);

  window.AerlessBundleMessagingAb = {
    refresh: applyTest,
    isEnabled: isAbEnabled,
    reset: function () {
      userPickedPack = false;
      defaultApplied = false;
      applyTest();
    }
  };
})();
